"use client";

import { useCommonConfigStore } from "@/shared";
import { useRouter, useSearchParams } from "next/navigation";
import { useForm, Controller } from "react-hook-form";
import { ArticleStatesSelect, AdminCommonCategoriesSelect } from "@/entities";

export function AdminArticlesFilter() {
  const { commonConfig } = useCommonConfigStore();

  const searchParams = useSearchParams();
  const router = useRouter();

  const state = searchParams?.get(`state`);
  const common_category_id = searchParams?.get(`common_category_id`) || "";
  const keyword = searchParams?.get(`keyword`) || "";

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: { state, common_category_id, keyword } });

  const onSubmit = async (data: any) => {
    let url = new URL(window.location.href);
    if (state) url.searchParams.set("state", state);
    else url.searchParams.delete("state");
    if (common_category_id) {
      url.searchParams.set("common_category_id", common_category_id);
    } else url.searchParams.delete("common_category_id");
    if (state) url.searchParams.set("state", state);
    else url.searchParams.delete("state");
    if (keyword) url.searchParams.set("keyword", keyword);
    else url.searchParams.delete("keyword");
    router.push(url.toString());
  };

  const commonCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let url = new URL(window.location.href);
    if (e.target.value) {
      url.searchParams.set("common_category_id", e.target.value);
    } else {
      url.searchParams.delete("common_category_id");
    }
    if (state) url.searchParams.set("state", state);
    else url.searchParams.delete("state");
    if (keyword) url.searchParams.set("keyword", keyword);
    else url.searchParams.delete("keyword");
    router.push(url.toString());
  };

  const onStateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let url = new URL(window.location.href);
    if (common_category_id)
      url.searchParams.set("common_category_id", common_category_id);
    else url.searchParams.delete("common_category_id");
    if (e.target.value) url.searchParams.set("state", e.target.value);
    else url.searchParams.delete("state");
    if (keyword) url.searchParams.set("keyword", keyword);
    else url.searchParams.delete("keyword");
    router.push(url.toString());
  };

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <div className="row">
            <div className="col-md-3 mb-3">
              <ArticleStatesSelect
                defaultValue={{ key: "", value: "전체상태" }}
                onChange={onStateChange}
                value={state ?? ""}
              />
            </div>
            {commonConfig.is_category && (
              <div className="col-md-3 mb-3">
                <AdminCommonCategoriesSelect
                  table={commonConfig.table}
                  slug={commonConfig.slug}
                  defalutValue={{ key: "", value: "전체분류" }}
                  onChange={commonCategoryChange}
                  value={common_category_id}
                />
              </div>
            )}
            <div className="col-md-5 mb-3"></div>
          </div>
        </div>

        <div className="col-md-4">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="input-group mb-4">
              <Controller
                control={control}
                name="keyword"
                render={({ field: { onChange, onBlur, value } }) => (
                  <input
                    type="text"
                    id="keyword"
                    className="form-control form-control-md"
                    title="검색어(제목, 내용)를 입력해주세요."
                    placeholder="검색어(제목, 내용)를 입력해주세요."
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                  />
                )}
              />
              <button className="btn btn-white btn-md" type="submit">
                <i className="fa fa-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
